import React from 'react';
import { ContentRow } from '../Summary.styled';
import { POTitleLabel, SumQtyLabel, PONumber } from './AddPoTitle.styled';
import { setCurrencyFormat, setCurrencyFormatWithoutSymbol } from 'src/utils/util';
import { getPriceInNumberDataType } from 'src/pages/consignmentBilling/utils/dataModificaionUtil';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const AddPoTitle = ({
    poTitle,
    isFromReportPaymentScreen,
    isFromConsignment,
    isPaymentScreen,
    reportPaymentGridData,
}) => {
    const handleAdjSumTotal = () => {
        let ajdSumTotalVal = 0;
        let isAdjustedPrice = reportPaymentGridData.some((item) =>
            Object.prototype.hasOwnProperty.call(item, 'adjustedUsedQtyPrice')
        );
        reportPaymentGridData.forEach((val) => {
            if (
                val.lotSerial[0].Used !== undefined &&
                val.lotSerial[0].Used !== null &&
                !val.basePrice &&
                val.basePrice !== undefined
            ) {
                if (
                    val.adjustedUsedQtyPrice !== undefined &&
                    val.adjustedUsedQtyPrice !== null
                ) {
                    ajdSumTotalVal =
                        ajdSumTotalVal +
                        Number(val.lotSerial[0].Used) *
                            getPriceInNumberDataType(val.adjustedUsedQtyPrice);
                } else {
                    ajdSumTotalVal =
                        ajdSumTotalVal +
                        Number(val.lotSerial[0].Used) *
                            getPriceInNumberDataType(val.adjustedUsedQtyPrice);
                }
            }
            if (
                val.otherQuantity !== undefined &&
                val.otherQuantity !== null &&
                !val.basePrice
            ) {
                if (
                    val.overrideUnitPrice !== undefined &&
                    val.overrideUnitPrice !== null
                ) {
                    ajdSumTotalVal =
                        ajdSumTotalVal +
                        Number(val.otherQuantity) *
                            getPriceInNumberDataType(val.overrideUnitPrice);
                } else {
                    ajdSumTotalVal =
                        ajdSumTotalVal +
                        Number(val.otherQuantity) *
                            getPriceInNumberDataType(val.adjustedUsedQtyPrice);
                }
            }
            if (
                val.basePrice !== undefined &&
                val.lotSerial[0].Used !== undefined &&
                val.lotSerial[0].Used !== '' &&
                isAdjustedPrice
            ) {
                ajdSumTotalVal =
                    ajdSumTotalVal +
                    Number(val.lotSerial[0].Used) *
                        getPriceInNumberDataType(
                            val.adjustedUsedQtyPrice
                                ? val.adjustedUsedQtyPrice
                                : val.basePrice
                        );
            }
        });
        return parseFloat(ajdSumTotalVal);
    }; 
    const { t } = useTranslation();
    const { isPriceOverRide } = useSelector((state) => ({
        isPriceOverRide: state.consignmentBilling.isPriceOverRide,
    }));

    return (
        <>
            {poTitle &&
                poTitle.map((el) => {
                    if (
                        el !== undefined &&
                        el !== null &&
                        el !== '' &&
                        el.poNumber !== undefined &&
                        el.poNumber !== null &&
                        el.poNumber !== ''
                    ) {
                        return (
                            <ContentRow>
                                {isFromReportPaymentScreen ? (
                                    <PONumber>{t('reportUsage.record.reportPayment.PoInfoView.poText')}{' '}<span className="summary-po-number-dt-mask">{el.poNumber}</span></PONumber>
                                ) : (
                                    <PONumber>{t('reportUsage.record.reportPayment.PoInfoView.poText')}{' '}<span className="summary-po-number-dt-mask">{el.poNumber}</span></PONumber>
                                )}

                                {isFromReportPaymentScreen && (
                                    <SumQtyLabel
                                        isPaymentScreen={isPaymentScreen}
                                    >
                                        {el.qty}
                                    </SumQtyLabel>
                                )}
                                {el.amount !== undefined &&
                                el.amount !== null &&
                                el.amount !== '' ? (
                                    <POTitleLabel
                                        isPaymentScreen={isPaymentScreen}
                                    >
                                        <div
                                            style={{
                                                color:
                                                    isFromConsignment &&
                                                    ((el.adjustedAmount !==
                                                        null &&
                                                        el.adjustedAmount !==
                                                            undefined &&
                                                        el.adjustedAmount !==
                                                            el.amount &&
                                                        !Number.isNaN(
                                                            el.adjustedAmount
                                                        )) ||
                                                        el.isPriceOverRide)
                                                        ? '#E5047E'
                                                        : '',
                                                textDecoration:
                                                    isFromConsignment &&
                                                    ((el.adjustedAmount !==
                                                        null &&
                                                        el.adjustedAmount !==
                                                            undefined &&
                                                        el.adjustedAmount !==
                                                            el.amount &&
                                                        !Number.isNaN(
                                                            el.adjustedAmount
                                                        )) ||
                                                        el.isPriceOverRide)
                                                        ? 'line-through'
                                                        : '',
                                            }}
                                        >
                                            {' '}
                                            {isFromReportPaymentScreen ? (isFromConsignment 
                                                ? `${setCurrencyFormatWithoutSymbol(el.amount)}`
                                                : `${setCurrencyFormat(el.amount)}`
                                            ) : `${setCurrencyFormat(el.amount)}`}
                                        </div>
                                        {isFromConsignment &&
                                            ((el.adjustedAmount !== null &&
                                                el.adjustedAmount !==
                                                    undefined &&
                                                el.adjustedAmount !==
                                                    el.amount &&
                                                !Number.isNaN(
                                                    el.adjustedAmount
                                                )) ||
                                                el.isPriceOverRide) && (
                                                <div>
                                                    {`${setCurrencyFormatWithoutSymbol(
                                                        poTitle.length > 1
                                                            ? el.adjustedAmount
                                                            : handleAdjSumTotal()
                                                    )}`}
                                                </div>
                                            )}
                                    </POTitleLabel>
                                ) : (
                                    <POTitleLabel>{}</POTitleLabel>
                                )}
                            </ContentRow>
                        );
                    }
                })}
        </>
    );
};
export default AddPoTitle;
